/* PDP photo viewer — assets/pdp-lightbox.js (Brett, 2026-10-14: "hover + click the image → it
   pops open with a big high-res photo"; trying it on the product page first).

   Click, tap or press Enter on the main product photo → a full-screen viewer grows out of the
   photo and shows the WHOLE product at full resolution. Every gallery photo is in it (arrows,
   ← →, swipe, the strip along the bottom); click / double-tap / pinch / wheel to zoom; Esc, ×
   or a click outside the photo closes it, and the page gallery lands on the photo you were
   looking at. The hover zoom on the page is untouched.

   Loaded ONLY by sections/product-info.liquid. Self-contained: its own CSS (injected once) and
   inline SVG icons, so it doesn't depend on the Font Awesome subset. Stays out of the way while
   the product video plays (.is-video) and while Logo Preview is on (html.pv-pdp).
   colorOf() mirrors theme.js extractColorName() — change both.
   Test: node scripts/tests/test-pdp-lightbox.js */
(function () {
  'use strict';
  var wrap = document.querySelector('.pdp__zoom-wrap');
  var main = document.getElementById('pdp-main-image');
  if (!wrap || !main || wrap.getAttribute('data-plb') === '1') return;
  wrap.setAttribute('data-plb', '1');

  var ZOOM = 2.5, ZMAX = 4;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var touchUI = !!(window.matchMedia && window.matchMedia('(hover: none)').matches);

  var CSS = [
    /* the page photo: says it can be opened */
    '.pdp__zoom-wrap.has-plb{cursor:zoom-in}',
    '.pdp__zoom-wrap.has-plb.is-video,html.pv-pdp .pdp__zoom-wrap.has-plb{cursor:default}',
    ".pdp__zoom-wrap.has-plb::after{content:'\\1F50D  Hover to zoom \\B7  Click to expand'}",
    ".pdp__zoom-wrap.has-plb.is-zoomed::after{content:'Click to see the whole photo';opacity:.92}",
    "@media (hover:none){.pdp__zoom-wrap.has-plb::after{content:'\\1F50D  Tap to expand'}}",
    '.pdp__zoom-wrap.has-plb:focus{outline:none}',
    '.pdp__zoom-wrap.has-plb:focus-visible{outline:3px solid #1a5fa8;outline-offset:3px}',
    'html.plb-lock,html.plb-lock body{overflow:hidden!important}',
    'html.plb-lock .idc-launch,html.plb-lock .idc-panel{visibility:hidden!important}',
    /* the viewer */
    '.plb{position:fixed;inset:0;z-index:100000;display:grid;grid-template-rows:auto minmax(0,1fr) auto auto;color:#fff;',
    "font-family:var(--font-body,'DM Sans',system-ui,sans-serif);-webkit-tap-highlight-color:transparent;user-select:none;-webkit-user-select:none;overscroll-behavior:contain}",
    '.plb[hidden]{display:none}',
    '.plb__bg{position:absolute;inset:0;background:rgba(9,14,24,.9);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);opacity:0;transition:opacity .32s ease}',
    '.plb.is-open .plb__bg{opacity:1}',
    '.plb__bar,.plb__strip,.plb__hint{position:relative;z-index:1;opacity:0;transition:opacity .28s ease,transform .34s cubic-bezier(.2,.8,.2,1)}',
    '.plb__bar{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:14px 18px 10px;transform:translateY(-10px)}',
    '.plb__strip{transform:translateY(10px)}',
    '.plb.is-open .plb__bar,.plb.is-open .plb__strip,.plb.is-open .plb__hint{opacity:1;transform:none}',
    '.plb__info{min-width:0}',
    ".plb__name{font:600 15px/1.3 var(--font-heading,Montserrat,sans-serif);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:min(760px,64vw)}",
    '.plb__sub{display:flex;align-items:center;flex-wrap:wrap;gap:6px 10px;margin-top:5px;font-size:12.5px;color:rgba(255,255,255,.66)}',
    '.plb__color{background:#1a5fa8;color:#fff;font-weight:600;padding:2px 10px;border-radius:999px;letter-spacing:.01em}',
    '.plb__color:empty,.plb__item:empty,.plb__count:empty{display:none}',
    '.plb__tools{display:flex;gap:8px;flex:none}',
    '.plb button{font:inherit;color:inherit}',
    '.plb__btn{width:42px;height:42px;border-radius:50%;border:1px solid rgba(255,255,255,.16);background:rgba(255,255,255,.08);color:#fff;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;padding:0;transition:background .15s,transform .15s}',
    '.plb__btn:hover{background:rgba(255,255,255,.2)}',
    '.plb__btn:active{transform:scale(.93)}',
    '.plb__btn svg,.plb__nav svg{width:20px;height:20px;display:block}',
    '.plb button:focus{outline:none}',
    '.plb button:focus-visible{outline:3px solid #7fb4ef;outline-offset:2px}',
    '.plb__stage{position:relative;z-index:1;display:flex;align-items:center;justify-content:center;min-height:0;overflow:hidden;touch-action:none}',
    '.plb__frame{position:relative;flex:none;background:#fff;border-radius:14px;overflow:hidden;cursor:zoom-in;box-shadow:0 34px 90px -24px rgba(0,0,0,.7),0 0 0 1px rgba(255,255,255,.06)}',
    '.plb.is-zoomed .plb__frame{cursor:zoom-out}',
    '.plb__img{display:block;width:100%;height:100%;object-fit:contain;transform-origin:50% 50%;-webkit-user-drag:none}',
    '.plb__img.is-anim{transition:transform .28s cubic-bezier(.2,.8,.2,1)}',
    '.plb__spin{position:absolute;right:12px;bottom:12px;width:18px;height:18px;border-radius:50%;border:2px solid rgba(26,95,168,.22);border-top-color:#1a5fa8;opacity:0;transition:opacity .2s;animation:plb-spin .8s linear infinite;pointer-events:none}',
    '.plb.is-loading .plb__spin{opacity:1}',
    '@keyframes plb-spin{to{transform:rotate(360deg)}}',
    '.plb__nav{position:absolute;top:50%;margin-top:-26px;z-index:2;width:52px;height:52px;border-radius:50%;border:1px solid rgba(255,255,255,.18);background:rgba(255,255,255,.1);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;opacity:0;transition:opacity .28s ease,background .15s,transform .15s}',
    '.plb.is-open .plb__nav{opacity:1}',
    '.plb__nav:hover{background:rgba(255,255,255,.22)}',
    '.plb__nav:active{transform:scale(.93)}',
    '.plb__nav--prev{left:18px}',
    '.plb__nav--next{right:18px}',
    '.plb__nav[hidden],.plb__strip[hidden]{display:none}',
    '.plb__strip{overflow-x:auto;overflow-y:hidden;padding:10px 18px 4px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.25) transparent}',
    '.plb__strip-in{display:flex;gap:8px;width:max-content;margin:0 auto;padding:4px 2px}',
    '.plb__th{flex:none;width:58px;height:58px;border-radius:10px;overflow:hidden;border:2px solid transparent;background:#fff;padding:0;cursor:pointer;opacity:.5;transition:opacity .15s,border-color .15s,transform .15s}',
    '.plb__th img{width:100%;height:100%;object-fit:contain;display:block}',
    '.plb__th:hover{opacity:.85}',
    '.plb__th.is-on{opacity:1;border-color:#fff;transform:translateY(-2px)}',
    '.plb__hint{text-align:center;font-size:12px;color:rgba(255,255,255,.5);padding:6px 16px calc(14px + env(safe-area-inset-bottom,0px))}',
    '@media (max-width:700px){.plb__bar{padding:10px 12px 8px}.plb__name{font-size:13.5px;max-width:62vw}.plb__btn{width:38px;height:38px}',
    '.plb__strip{padding:8px 12px 2px}.plb__th{width:46px;height:46px;border-radius:8px}.plb__frame{border-radius:10px}}',
    '@media (max-width:700px),(hover:none){.plb__nav{display:none}}',
    '@media (prefers-reduced-motion:reduce){.plb__bg,.plb__bar,.plb__strip,.plb__hint,.plb__nav{transition:opacity .15s linear}.plb__bar,.plb__strip{transform:none}.plb__img.is-anim{transition:none}.plb__spin{animation-duration:2s}}'
  ].join('\n');

  var ICON = {
    close: '<path d="M6 6l12 12M18 6L6 18"/>',
    prev: '<path d="M15 5l-7 7 7 7"/>',
    next: '<path d="M9 5l7 7-7 7"/>',
    zin: '<circle cx="10.5" cy="10.5" r="6.5"/><path d="M20 20l-4.6-4.6M10.5 7.6v5.8M7.6 10.5h5.8"/>',
    zout: '<circle cx="10.5" cy="10.5" r="6.5"/><path d="M20 20l-4.6-4.6M7.6 10.5h5.8"/>'
  };
  function svg(k) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + ICON[k] + '</svg>';
  }

  // mirrors theme.js extractColorName() (the "Black" badge on the page photo)
  function colorOf(alt) {
    if (!alt) return '';
    var i = alt.indexOf(' - ');
    if (i === -1) return '';
    var raw = alt.substring(i + 3).trim();
    if (!raw) return '';
    return raw
      .replace(/^D\s?Blue$/i, 'Dark Blue')
      .replace(/^D\s?Gray$/i, 'Dark Gray')
      .replace(/^D\s?Green$/i, 'Dark Green')
      .replace(/^L\s?Blue$/i, 'Light Blue')
      .replace(/^L\s?Green$/i, 'Light Green')
      .replace(/^N\s?Blue$/i, 'Navy Blue')
      .replace(/^P\s?Blue$/i, 'Process Blue')
      .replace(/^R\s?Blue$/i, 'Royal Blue')
      .replace(/^RO\s?Blue$/i, 'Royal Blue')
      .replace(/^RO\s?Orange$/i, 'Red Orange')
      .replace(/^H\s?Pink$/i, 'Hot Pink')
      .replace(/^J\s?Green$/i, 'Jade Green')
      .replace(/^K\s?Green$/i, 'Kelly Green')
      .replace(/^3Q$/i, '3/4 View');
  }

  function txt(sel) {
    var n = document.querySelector(sel);
    return n ? (n.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }
  function photoThumbs() {
    return Array.prototype.slice.call(document.querySelectorAll('#pdp-thumbs .pdp__thumb:not(.pdp__thumb--video)'));
  }
  function photos() {
    var t = photoThumbs();
    if (!t.length) {
      var s = main.getAttribute('src');
      return [{ full: s, hi: wrap.getAttribute('data-zoom-src') || s, alt: main.getAttribute('alt') || '', thumb: null, tsrc: s }];
    }
    return t.map(function (el) {
      var full = el.getAttribute('data-full') || el.getAttribute('src');
      return {
        full: full,
        hi: el.getAttribute('data-zoom') || full,
        alt: el.getAttribute('alt') || '',
        thumb: el,
        tsrc: (el.getAttribute('src') || full).replace(/([?&]width=)\d+/, '$1160')
      };
    });
  }
  function activeIndex(list) {
    for (var i = 0; i < list.length; i++) if (list[i].thumb && list[i].thumb.classList.contains('is-active')) return i;
    return 0;
  }

  /* ── state ── */
  var el = null, list = [], idx = 0, isOpen = false, closing = false;
  var W = 0, H = 0, ar = 1, z = 1, tx = 0, ty = 0, animUntil = 0;
  var loadToken = 0, opener = null, prevPad = '', lastType = 'mouse';
  var pts = {}, pinch = null, drag = null, lastTap = 0, lastTapX = 0, lastTapY = 0;

  function injectCss() {
    if (document.getElementById('plb-css')) return;
    var st = document.createElement('style');
    st.id = 'plb-css';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function build() {
    if (el) return;
    injectCss();
    var root = document.createElement('div');
    root.className = 'plb';
    root.id = 'pdp-lightbox';
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Product photos');
    root.innerHTML =
      '<div class="plb__bg"></div>' +
      '<div class="plb__bar">' +
        '<div class="plb__info"><div class="plb__name"></div>' +
          '<div class="plb__sub"><span class="plb__color"></span><span class="plb__item"></span><span class="plb__count" aria-live="polite"></span></div></div>' +
        '<div class="plb__tools">' +
          '<button type="button" class="plb__btn plb__btn--zoom" title="Zoom (Z)" aria-label="Zoom in">' + svg('zin') + '</button>' +
          '<button type="button" class="plb__btn plb__btn--close" title="Close (Esc)" aria-label="Close">' + svg('close') + '</button>' +
        '</div>' +
      '</div>' +
      '<div class="plb__stage">' +
        '<button type="button" class="plb__nav plb__nav--prev" aria-label="Previous photo" title="Previous (←)">' + svg('prev') + '</button>' +
        '<div class="plb__frame"><img class="plb__img" alt="" draggable="false"><span class="plb__spin" aria-hidden="true"></span></div>' +
        '<button type="button" class="plb__nav plb__nav--next" aria-label="Next photo" title="Next (→)">' + svg('next') + '</button>' +
      '</div>' +
      '<div class="plb__strip"><div class="plb__strip-in"></div></div>' +
      '<div class="plb__hint"></div>';
    document.body.appendChild(root);
    el = {
      root: root,
      bg: root.querySelector('.plb__bg'),
      bar: root.querySelector('.plb__bar'),
      name: root.querySelector('.plb__name'),
      color: root.querySelector('.plb__color'),
      item: root.querySelector('.plb__item'),
      count: root.querySelector('.plb__count'),
      zoomBtn: root.querySelector('.plb__btn--zoom'),
      closeBtn: root.querySelector('.plb__btn--close'),
      stage: root.querySelector('.plb__stage'),
      prev: root.querySelector('.plb__nav--prev'),
      next: root.querySelector('.plb__nav--next'),
      frame: root.querySelector('.plb__frame'),
      img: root.querySelector('.plb__img'),
      strip: root.querySelector('.plb__strip'),
      stripIn: root.querySelector('.plb__strip-in'),
      hint: root.querySelector('.plb__hint')
    };
    bind();
  }

  /* ── layout + zoom ── */
  function fit() {
    var r = el.stage.getBoundingClientRect();
    var wide = r.width > 700 && !touchUI;
    var padX = wide ? 88 : 10, padY = wide ? 16 : 8;
    var aw = Math.max(80, r.width - padX * 2), ah = Math.max(80, r.height - padY * 2);
    var a = ar > 0 ? ar : 1;
    var w = Math.min(aw, ah * a);
    W = Math.round(w);
    H = Math.round(w / a);
    el.frame.style.width = W + 'px';
    el.frame.style.height = H + 'px';
  }
  function clampT() {
    var mx = W * (z - 1) / 2, my = H * (z - 1) / 2;
    tx = Math.max(-mx, Math.min(mx, tx));
    ty = Math.max(-my, Math.min(my, ty));
  }
  function applyZ(anim) {
    clampT();
    el.img.classList.toggle('is-anim', !!anim);
    el.img.style.transform = (z === 1 && !tx && !ty) ? '' : 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + z + ')';
    var zoomed = z > 1.01;
    el.root.classList.toggle('is-zoomed', zoomed);
    var want = zoomed ? 'zout' : 'zin';
    if (el.zoomBtn.getAttribute('data-i') !== want) {
      el.zoomBtn.setAttribute('data-i', want);
      el.zoomBtn.innerHTML = svg(want);
      el.zoomBtn.setAttribute('aria-label', zoomed ? 'Zoom out' : 'Zoom in');
    }
  }
  // zoom to z2 keeping the screen point (sx, sy) where it is
  function zoomAt(z2, sx, sy, anim) {
    z2 = Math.max(1, Math.min(ZMAX, z2));
    var fr = el.frame.getBoundingClientRect();
    var cx = fr.left + fr.width / 2, cy = fr.top + fr.height / 2;
    var k = z2 / z;
    tx = (sx - cx) - k * (sx - cx - tx);
    ty = (sy - cy) - k * (sy - cy - ty);
    z = z2;
    if (z <= 1.001) { z = 1; tx = 0; ty = 0; }
    if (anim) animUntil = Date.now() + 300;
    applyZ(anim);
  }
  function frameCenter() {
    var fr = el.frame.getBoundingClientRect();
    return { x: fr.left + fr.width / 2, y: fr.top + fr.height / 2 };
  }
  function toggleZoom(sx, sy) {
    if (z > 1.01) zoomAt(1, sx, sy, true);
    else zoomAt(ZOOM, sx, sy, true);
  }
  function resetZ() { z = 1; tx = 0; ty = 0; applyZ(false); }

  /* ── content ── */
  function load(p) {
    var token = ++loadToken;
    el.root.classList.remove('is-loading');
    el.img.onload = function () {
      if (token !== loadToken || !el.img.naturalWidth) return;
      var a = el.img.naturalWidth / el.img.naturalHeight;
      if (Math.abs(a - ar) > 0.005) { ar = a; fit(); resetZ(); }
    };
    el.img.alt = p.alt || '';
    el.img.src = p.full;
    if (el.img.complete && el.img.naturalWidth) ar = el.img.naturalWidth / el.img.naturalHeight;
    fit();
    if (p.hi && p.hi !== p.full) {
      el.root.classList.add('is-loading');
      var hi = new Image();
      var swap = function () {
        if (token !== loadToken) return;
        el.img.src = hi.src;
        el.root.classList.remove('is-loading');
      };
      hi.onload = function () {
        if (token !== loadToken) return;
        if (hi.decode) hi.decode().then(swap, swap); else swap();
      };
      hi.onerror = function () { if (token === loadToken) el.root.classList.remove('is-loading'); };
      hi.src = p.hi;
    }
    // warm the neighbours so the arrows feel instant
    var n = list.length;
    if (n > 1) [idx + 1, idx - 1].forEach(function (j) { var im = new Image(); im.src = list[(j + n) % n].full; });
  }
  function setInfo() {
    var p = list[idx], n = list.length;
    el.name.textContent = txt('.pdp__title') || main.getAttribute('alt') || '';
    el.color.textContent = colorOf(p.alt);
    el.item.textContent = txt('.pdp__item-number');
    el.count.textContent = n > 1 ? (idx + 1) + ' / ' + n : '';
    el.prev.hidden = el.next.hidden = n < 2;
    var kids = el.stripIn.children;
    for (var i = 0; i < kids.length; i++) {
      var on = i === idx;
      kids[i].classList.toggle('is-on', on);
      if (on) kids[i].setAttribute('aria-current', 'true'); else kids[i].removeAttribute('aria-current');
    }
    var b = kids[idx];
    if (b && el.strip.scrollWidth > el.strip.clientWidth) {
      var left = b.offsetLeft - el.strip.clientWidth / 2 + b.offsetWidth / 2; // .plb__strip is the offsetParent
      if (el.strip.scrollTo) el.strip.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
      else el.strip.scrollLeft = Math.max(0, left);
    }
  }
  function buildStrip() {
    el.stripIn.innerHTML = '';
    el.strip.hidden = list.length < 2;
    if (list.length < 2) return;
    list.forEach(function (p, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'plb__th';
      var c = colorOf(p.alt);
      b.setAttribute('aria-label', 'Photo ' + (i + 1) + (c ? ': ' + c : ''));
      if (c) b.title = c;
      var im = document.createElement('img');
      im.src = p.tsrc;
      im.alt = '';
      im.decoding = 'async';
      b.appendChild(im);
      b.addEventListener('click', function () { go(i, i > idx ? 1 : -1); });
      el.stripIn.appendChild(b);
    });
  }
  function setHint() {
    var many = list.length > 1;
    el.hint.textContent = touchUI
      ? 'Double-tap or pinch to zoom' + (many ? ' · Swipe for more photos' : '')
      : 'Click the photo to zoom' + (many ? ' · ← → for more photos' : '') + ' · Esc to close';
  }
  function show(animate, dir) {
    el.frame.style.transform = '';
    el.frame.style.opacity = '';
    resetZ();
    setInfo();
    load(list[idx]);
    if (animate && !reduce && el.frame.animate) {
      el.frame.animate(
        [{ opacity: 0, transform: 'translate3d(' + (dir * 48) + 'px,0,0) scale(.97)' }, { opacity: 1, transform: 'none' }],
        { duration: 280, easing: 'cubic-bezier(.2,.8,.2,1)' }
      );
    }
  }
  function go(i, dir) {
    var n = list.length;
    if (n < 2 || closing) return;
    i = ((i % n) + n) % n;
    if (i === idx) return;
    idx = i;
    show(true, dir || 1);
  }

  /* ── open / close ── */
  // where the photo sits on the page (the contain box inside the gallery frame, ignoring the hover zoom)
  function srcBox() {
    if (!main.offsetWidth || !main.offsetHeight) return null;
    var r = wrap.getBoundingClientRect();
    var cs = window.getComputedStyle(main);
    var pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0;
    var pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
    var bx = r.left + wrap.clientLeft + main.offsetLeft + pl;
    var by = r.top + wrap.clientTop + main.offsetTop + pt;
    var bw = main.offsetWidth - pl - pr, bh = main.offsetHeight - pt - pb;
    if (bw <= 0 || bh <= 0) return null;
    var a = ar > 0 ? ar : 1;
    var w = Math.min(bw, bh * a), h = w / a;
    return { left: bx + (bw - w) / 2, top: by + (bh - h) / 2, width: w, height: h,
      ox: pl + (bw - w) / 2, oy: pt + (bh - h) / 2 }; // image offset inside the page photo element
  }
  // the page photo's hover zoom right now: scale(S) translate(x,y) about its top-left (see product-info.liquid)
  function hoverZoom() {
    var m = /scale\(([\d.]+)\)\s*translate\(\s*([-\d.e]+)px\s*,\s*([-\d.e]+)px\s*\)/.exec(main.style.transform || '');
    if (!m) return null;
    var S = parseFloat(m[1]);
    return S > 1.01 ? { s: S, x: parseFloat(m[2]) || 0, y: parseFloat(m[3]) || 0 } : null;
  }
  // the viewer image transform that shows exactly what the hover-zoomed page photo shows
  function hoverStartT(hz, from) {
    var kx = W / from.width, ky = H / from.height;
    var Tx = kx * (hz.s * from.ox + hz.s * hz.x - from.ox) + (hz.s - 1) * W / 2;
    var Ty = ky * (hz.s * from.oy + hz.s * hz.y - from.oy) + (hz.s - 1) * H / 2;
    return 'translate(' + Tx + 'px,' + Ty + 'px) scale(' + hz.s + ')';
  }
  function flipT(from, to) {
    var s = from.width / to.width;
    var dx = (from.left + from.width / 2) - (to.left + to.width / 2);
    var dy = (from.top + from.height / 2) - (to.top + to.height / 2);
    return 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ')';
  }
  function lock() {
    var de = document.documentElement;
    var sw = window.innerWidth - de.clientWidth;
    prevPad = document.body.style.paddingRight;
    if (sw > 0) document.body.style.paddingRight = sw + 'px';
    de.classList.add('plb-lock');
  }
  function unlock() {
    document.documentElement.classList.remove('plb-lock');
    document.body.style.paddingRight = prevPad;
  }
  function blocked() {
    return document.documentElement.classList.contains('pv-pdp') || wrap.classList.contains('is-video');
  }

  function open() {
    if (isOpen || blocked()) return;
    build();
    list = photos();
    idx = activeIndex(list);
    opener = document.activeElement;
    var hz = reduce ? null : hoverZoom(); // read BEFORE the reset below
    // put the page photo back to its resting state (the hover zoom); the viewer grows from it
    try { wrap.dispatchEvent(new Event('mouseleave')); } catch (_) {}
    ar = (main.naturalWidth && main.naturalHeight) ? main.naturalWidth / main.naturalHeight : 1;
    lock();
    el.root.hidden = false;
    isOpen = true;
    closing = false;
    buildStrip();
    setHint();
    show(false, 1);
    var to = el.frame.getBoundingClientRect();
    var from = srcBox();
    void el.root.offsetWidth; // commit the closed state so the fades run
    el.root.classList.add('is-open');
    if (el.frame.animate) {
      if (!reduce && from && to.width) {
        el.frame.animate([{ transform: flipT(from, to) }, { transform: 'none' }],
          { duration: 460, easing: 'cubic-bezier(.2,1.22,.36,1)' });
        // opened while hover-zoomed: start on the same close-up, then pull back to the whole product
        if (hz && from.width) {
          el.img.animate([{ transform: hoverStartT(hz, from) }, { transform: 'none' }],
            { duration: 560, easing: 'cubic-bezier(.3,.7,.2,1)' });
        }
      } else {
        el.frame.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180 });
      }
    }
    try { el.closeBtn.focus({ preventScroll: true }); } catch (_) { el.closeBtn.focus(); }
    document.addEventListener('keydown', onKey, true);
  }

  function close() {
    if (!isOpen || closing) return;
    closing = true;
    document.removeEventListener('keydown', onKey, true);
    pts = {}; pinch = null; drag = null;
    // the page gallery lands on the photo that was being viewed
    var p = list[idx];
    if (p && p.thumb && !p.thumb.classList.contains('is-active')) { try { p.thumb.click(); } catch (_) {} }
    resetZ();
    el.frame.style.transform = '';
    el.frame.style.opacity = '';
    el.root.classList.remove('is-open', 'is-loading');
    var from = el.frame.getBoundingClientRect();
    var to = srcBox();
    var onScreen = to && to.top + to.height > 0 && to.top < window.innerHeight;
    var finished = false;
    function done() {
      if (finished) return;
      finished = true;
      el.root.hidden = true;
      isOpen = false;
      closing = false;
      ++loadToken;
      unlock();
      var back = opener && document.body.contains(opener) && opener !== document.body ? opener : wrap;
      try { back.focus({ preventScroll: true }); } catch (_) {}
    }
    if (el.frame.animate) {
      var a = (!reduce && onScreen && from.width)
        ? el.frame.animate([{ transform: 'none' }, { transform: flipT(to, from) }], { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' })
        : el.frame.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(.96)' }], { duration: 170, easing: 'ease-in', fill: 'forwards' });
      a.onfinish = function () { done(); try { a.cancel(); } catch (_) {} };
      setTimeout(function () { done(); try { a.cancel(); } catch (_) {} }, 700); // never stuck open
    } else {
      done();
    }
  }

  /* ── input ── */
  function onKey(e) {
    if (!isOpen) return;
    var k = e.key, handled = true;
    if (k === 'Escape' || k === 'Esc') close();
    else if (k === 'ArrowRight') go(idx + 1, 1);
    else if (k === 'ArrowLeft') go(idx - 1, -1);
    else if (k === '+' || k === '=') { var c1 = frameCenter(); zoomAt(z * 1.5, c1.x, c1.y, true); }
    else if (k === '-' || k === '_') { var c2 = frameCenter(); zoomAt(z / 1.5, c2.x, c2.y, true); }
    else if ((k === 'z' || k === 'Z') && !e.ctrlKey && !e.metaKey) { var c3 = frameCenter(); toggleZoom(c3.x, c3.y); }
    else if (k === 'Tab') {
      var f = Array.prototype.filter.call(el.root.querySelectorAll('button'), function (b) { return !b.hidden && b.offsetParent !== null; });
      if (f.length) {
        var first = f[0], last = f[f.length - 1], a = document.activeElement;
        if (!el.root.contains(a)) { e.preventDefault(); first.focus(); }
        else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
      }
      return;
    } else handled = false;
    if (handled) { e.preventDefault(); e.stopPropagation(); }
  }

  function dist(a, b) { return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y)); }
  function springBack() {
    var cur = el.frame.style.transform, op = el.frame.style.opacity;
    el.frame.style.transform = '';
    el.frame.style.opacity = '';
    if (cur && !reduce && el.frame.animate) {
      el.frame.animate([{ transform: cur, opacity: op || 1 }, { transform: 'none', opacity: 1 }], { duration: 200, easing: 'ease-out' });
    }
  }

  function bind() {
    el.closeBtn.addEventListener('click', close);
    el.zoomBtn.addEventListener('click', function () { var c = frameCenter(); toggleZoom(c.x, c.y); });
    el.prev.addEventListener('click', function (e) { e.stopPropagation(); go(idx - 1, -1); });
    el.next.addEventListener('click', function (e) { e.stopPropagation(); go(idx + 1, 1); });

    // empty space around the photo closes the viewer
    el.root.addEventListener('click', function (e) {
      var t = e.target;
      if (t === el.root || t === el.bg || t === el.bar || t === el.hint || t === el.strip) close();
    });

    // mouse: click the photo to zoom, move to look around (like the page hover zoom), click outside to close
    el.stage.addEventListener('click', function (e) {
      if (lastType !== 'mouse') return;
      if (e.target.closest && e.target.closest('.plb__nav')) return;
      if (e.target.closest && e.target.closest('.plb__frame')) { toggleZoom(e.clientX, e.clientY); return; }
      close();
    });
    el.frame.addEventListener('mousemove', function (e) {
      if (lastType !== 'mouse' || z <= 1.01) return;
      var fr = el.frame.getBoundingClientRect();
      var fx = Math.max(0, Math.min(1, (e.clientX - fr.left) / fr.width));
      var fy = Math.max(0, Math.min(1, (e.clientY - fr.top) / fr.height));
      tx = (0.5 - fx) * W * (z - 1);
      ty = (0.5 - fy) * H * (z - 1);
      applyZ(Date.now() < animUntil);
    });
    el.stage.addEventListener('wheel', function (e) {
      if (!isOpen) return;
      e.preventDefault();
      var step = Math.min(1.35, 1 + Math.abs(e.deltaY) / 400);
      zoomAt(e.deltaY < 0 ? z * step : z / step, e.clientX, e.clientY, false);
    }, { passive: false });

    // touch / pen: swipe between photos, drag to look around when zoomed, pinch + double-tap to zoom
    el.root.addEventListener('pointerdown', function (e) { lastType = e.pointerType || 'mouse'; }, true);
    el.stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      if (e.target.closest && e.target.closest('.plb__nav')) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { el.stage.setPointerCapture(e.pointerId); } catch (_) {}
      var ids = Object.keys(pts);
      if (ids.length >= 2) {
        var a = pts[ids[0]], b = pts[ids[1]];
        pinch = { d: dist(a, b) || 1, z: z, lx: (a.x + b.x) / 2, ly: (a.y + b.y) / 2 };
        drag = null;
        springBack();
      } else {
        drag = { x: e.clientX, y: e.clientY, tx: tx, ty: ty, t: Date.now(), moved: false,
          onFrame: !!(e.target.closest && e.target.closest('.plb__frame')) };
      }
    });
    el.stage.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (pinch) {
        var ids = Object.keys(pts);
        if (ids.length < 2) return;
        var a = pts[ids[0]], b = pts[ids[1]];
        var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
        zoomAt(pinch.z * dist(a, b) / pinch.d, mx, my, false);
        tx += mx - pinch.lx;
        ty += my - pinch.ly;
        pinch.lx = mx; pinch.ly = my;
        applyZ(false);
        return;
      }
      if (!drag) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (Math.abs(dx) + Math.abs(dy) > 8) drag.moved = true;
      if (z > 1.01) { tx = drag.tx + dx; ty = drag.ty + dy; applyZ(false); }
      else if (list.length > 1 && drag.moved) {
        el.frame.style.transform = 'translate3d(' + dx + 'px,0,0)';
        el.frame.style.opacity = String(Math.max(0.35, 1 - Math.abs(dx) / 700));
      }
    });
    function endPtr(e) {
      if (!pts[e.pointerId]) return;
      delete pts[e.pointerId];
      var left = Object.keys(pts);
      if (pinch) {
        if (left.length < 2) {
          pinch = null;
          if (z < 1.05) { var c = frameCenter(); zoomAt(1, c.x, c.y, true); }
          // a finger still down carries on as a drag
          drag = left.length ? { x: pts[left[0]].x, y: pts[left[0]].y, tx: tx, ty: ty, t: 0, moved: true, onFrame: true } : null;
        }
        return;
      }
      if (!drag) return;
      var d = drag;
      drag = null;
      if (e.type !== 'pointerup') { springBack(); return; }
      var dx = e.clientX - d.x, dy = e.clientY - d.y;
      if (d.moved) {
        if (z <= 1.01 && list.length > 1) {
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
          else springBack();
        }
        return;
      }
      // a tap
      var now = Date.now();
      if (!d.onFrame) { if (z <= 1.01) close(); return; }
      if (now - lastTap < 320 && Math.abs(e.clientX - lastTapX) < 40 && Math.abs(e.clientY - lastTapY) < 40) {
        lastTap = 0;
        toggleZoom(e.clientX, e.clientY);
      } else {
        lastTap = now; lastTapX = e.clientX; lastTapY = e.clientY;
      }
    }
    el.stage.addEventListener('pointerup', endPtr);
    el.stage.addEventListener('pointercancel', endPtr);

    window.addEventListener('resize', function () {
      if (!isOpen || closing) return;
      fit();
      resetZ();
    });
  }

  /* ── the page photo opens it ── */
  wrap.classList.add('has-plb');
  if (!wrap.hasAttribute('tabindex')) wrap.setAttribute('tabindex', '0');
  wrap.setAttribute('role', 'button');
  wrap.setAttribute('aria-label', 'Open the full-size product photos');
  wrap.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.pdp__video-frame')) return;
    open();
  });
  wrap.addEventListener('keydown', function (e) {
    if (e.target !== wrap) return;
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); open(); }
  });
  // the CSS also styles the page photo (cursor + "Click to expand" pill), so load it now
  injectCss();
})();
